module.exports = __webpack_public_path__ + "static/confetti-stamps-left-large-127fef8be3d462c4c5d46702bcde8f80.svg";